"use strict";
/**
 * MobileProcessor Service file
 */
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileProcessorService = void 0;
const Identifiers_1 = require("./../../lib/constant/Identifiers");
const KushkiError_1 = require("./../../lib/generic/KushkiError");
const ErrorEnum_1 = require("./../../lib/infrastructure/ErrorEnum");
const inversify_1 = require("inversify");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
let MobileProcessorService = class MobileProcessorService {
    constructor(gateway) {
        this._gateway = gateway;
    }
    // istanbul ignore next
    requestToken(request, publicCredential, isTest, regional) {
        let token;
        const apple_request = this.createAppleRequest(request);
        return rxjs_1.of(1).pipe(operators_1.mergeMap(() => new rxjs_1.Observable((observer) => {
            // tslint:disable-next-line:no-any
            const apple_session = new window.ApplePaySession(2, apple_request);
            apple_session.onvalidatemerchant = (event) => this.onvalidatemerchant(event, observer, apple_session);
            apple_session.begin();
        })), operators_1.mergeMap((session) => this.requestGatewayToken(request, session, publicCredential, isTest, regional)), operators_1.mergeMap(([session, response]) => {
            token = response.token;
            delete response.token;
            session.session.completeMerchantValidation(response);
            return rxjs_1.of(session);
        }), operators_1.mergeMap((session) => new rxjs_1.Observable((observer) => {
            session.session.onpaymentauthorized = (event) => {
                observer.next({
                    payment_token: event.payment,
                    session: session.session,
                });
            };
        })), operators_1.mergeMap((session) => {
            session.session.completePayment(
            // tslint:disable-next-line:no-any
            window.ApplePaySession.STATUS_SUCCESS);
            return rxjs_1.of({
                token,
                paymentToken: session.payment_token,
            });
        }), operators_1.catchError((error) => {
            if (error.message ===
                "The object does not support the operation or argument.")
                return rxjs_1.throwError(new KushkiError_1.KushkiError(ErrorEnum_1.ERRORS.E006));
            return rxjs_1.throwError(error);
        }));
    }
    requestGatewayToken(request, session, publicCredential, isTest, regional) {
        request.validationUrl = session.validation_url;
        request.domainName = session.current_url;
        delete request.description;
        return rxjs_1.forkJoin([
            rxjs_1.of(session),
            this._gateway.requestMobileProcessorToken(request, publicCredential, isTest, regional),
        ]).pipe(operators_1.catchError((err) => {
            session.session.abort();
            return rxjs_1.throwError(err);
        }));
    }
    requestGatewayCharge(token, publicCredential, isTest, regional, request, session) {
        const charge_request = {
            token,
            amount: request.totalAmount,
            currency: request.currency,
            encodedPaymentToken: session.payment_token,
            softDescriptor: "KushkiPagos",
        };
        return rxjs_1.forkJoin([
            rxjs_1.of(session),
            this._gateway.chargeMobileProcessor(charge_request, publicCredential, isTest, regional),
        ]);
    }
    createAppleRequest(request) {
        return {
            countryCode: "US",
            currencyCode: "USD",
            merchantCapabilities: ["supports3DS"],
            requiredBillingContactFields: ["postalAddress", "name"],
            requiredShippingContactFields: ["postalAddress", "email", "phone"],
            supportedNetworks: ["amex", "discover", "jcb", "masterCard", "visa"],
            total: {
                amount: request.totalAmount,
                label: request.description,
                type: "final",
            },
        };
    }
    completePayment(session, response) {
        session.session.completePayment(
        // tslint:disable-next-line:no-any
        window.ApplePaySession.STATUS_SUCCESS);
        return rxjs_1.of(response);
    }
    onvalidatemerchant(event, observer, session) {
        const validation_url = event.validationURL;
        const current_url = window.location.host;
        observer.next({ current_url, validation_url, session });
    }
    paymentAuthorized(event, observer, session) {
        const payment_token = event.payment;
        observer.next({ payment_token, session: session.session });
    }
};
MobileProcessorService = __decorate([
    inversify_1.injectable(),
    __param(0, inversify_1.inject(Identifiers_1.IDENTIFIERS.KushkiGateway)),
    __metadata("design:paramtypes", [Object])
], MobileProcessorService);
exports.MobileProcessorService = MobileProcessorService;
